Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.inputTypes = exports.defaultProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _inputTypes = require('../constants/inputTypes');

var _inputTypes2 = _interopRequireDefault(_inputTypes);

var _FormElement = require('../private/FormElement');

var _FormElement2 = _interopRequireDefault(_FormElement);

var _InputOnly = require('../private/Forms/InputOnly');

var _InputOnly2 = _interopRequireDefault(_InputOnly);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = Object.assign({}, _FormElement.propTypes, _InputOnly.propTypes);

var defaultProps = exports.defaultProps = Object.assign({}, _FormElement.defaultProps, _InputOnly.defaultProps);

var Input = function (_React$PureComponent) {
  _inherits(Input, _React$PureComponent);

  function Input() {
    _classCallCheck(this, Input);

    return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
  }

  _createClass(Input, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            actionLink = _props.actionLink,
            autoCapitalize = _props.autoCapitalize,
            autoComplete = _props.autoComplete,
            autoCorrect = _props.autoCorrect,
            autoFocus = _props.autoFocus,
            spellCheck = _props.spellCheck,
            book = _props.book,
            borderless = _props.borderless,
            focusBorderless = _props.focusBorderless,
            disabled = _props.disabled,
            errorMessage = _props.errorMessage,
            hasExternalLabel = _props.hasExternalLabel,
            hideLabel = _props.hideLabel,
            lightLabel = _props.lightLabel,
            id = _props.id,
            inline = _props.inline,
            invalid = _props.invalid,
            inputRef = _props.inputRef,
            inverse = _props.inverse,
            label = _props.label,
            labelDescription = _props.labelDescription,
            maxLength = _props.maxLength,
            name = _props.name,
            onChange = _props.onChange,
            onClear = _props.onClear,
            onBlur = _props.onBlur,
            onFocus = _props.onFocus,
            onKeyDown = _props.onKeyDown,
            placeholder = _props.placeholder,
            showFakeValuePlaceholder = _props.showFakeValuePlaceholder,
            prefix = _props.prefix,
            readOnly = _props.readOnly,
            refForFocus = _props.refForFocus,
            role = _props.role,
            value = _props.value,
            small = _props.small,
            large = _props.large,
            type = _props.type,
            underlineFocus = _props.underlineFocus,
            removeMargins = _props.removeMargins,
            showOverflowEllipsis = _props.showOverflowEllipsis,
            suffix = _props.suffix,
            suffixText = _props.suffixText,
            ampVarsInputName = _props.ampVarsInputName,
            velouteId = _props.velouteId;


        var errorMessageID = errorMessage ? String(id) + '_error' : undefined;
        return _react2['default'].createElement(
          _FormElement2['default'],
          _extends({}, invalid && { errorMessage: errorMessage, errorMessageID: errorMessageID }, hasExternalLabel && { hasExternalLabel: hasExternalLabel }, !hasExternalLabel && { label: label, labelDescription: labelDescription, lightLabel: lightLabel, hideLabel: hideLabel }, {
            actionLink: actionLink,
            id: id,
            inline: inline,
            invalid: invalid,
            inverse: inverse,
            large: large,
            small: small
          }),
          _react2['default'].createElement(_InputOnly2['default'], _extends({}, invalid && { errorMessageID: errorMessageID }, {
            autoCapitalize: autoCapitalize,
            autoComplete: autoComplete,
            autoCorrect: autoCorrect,
            autoFocus: autoFocus,
            spellCheck: spellCheck,
            book: book,
            borderless: borderless,
            focusBorderless: focusBorderless,
            disabled: disabled,
            id: id,
            inline: inline,
            inverse: inverse,
            inputRef: inputRef,
            invalid: invalid,
            maxLength: maxLength,
            name: name,
            onBlur: onBlur,
            onChange: onChange,
            onClear: onClear,
            onFocus: onFocus,
            onKeyDown: onKeyDown,
            placeholder: placeholder,
            showFakeValuePlaceholder: showFakeValuePlaceholder,
            prefix: prefix,
            readOnly: readOnly,
            refForFocus: refForFocus,
            role: role,
            value: value,
            small: small,
            large: large,
            type: type,
            underlineFocus: underlineFocus,
            removeMargins: removeMargins,
            showOverflowEllipsis: showOverflowEllipsis,
            suffixText: suffixText,
            suffix: suffix,
            ampVarsInputName: ampVarsInputName,
            velouteId: velouteId
          }))
        );
      }

      return render;
    }()
  }]);

  return Input;
}(_react2['default'].PureComponent);

Input.componentCategory = 'Core';
Input.displayName = 'Input';
exports['default'] = Input;


Input.propTypes = (0, _airbnbPropTypes.forbidExtraProps)(propTypes);
Input.defaultProps = defaultProps;
Input.inputTypes = _inputTypes2['default'];

exports.inputTypes = _inputTypes2['default'];
exports.propTypes = propTypes;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/Input.js
// module id = 410
// module chunks = 923280921217